import request from "@/utils/requset";
import apiUtill from "@/utils/apiUtill";
import { apiModules } from "@/api/interface";

// import.meta.glob
const files: any = import.meta.glob("./module/*.ts", { eager: true });

const modules: apiModules = {};
for (const key in files) {
  modules[key.replace(/(\.\/module\/|\.ts)/g, "")] = apiUtill(request, files[key].default);
}

export default modules;
